import { useContext, useEffect, useState } from 'react';
import { UserContext, UserContextProps } from 'contexts/UserContext';
import useAPIAuth from 'hooks/api/useAPIAuth';
import { ROUTES } from 'constants/routes';

/**
 * Fetches a one-time auto-login token for the current user and returns the
 * full auto-login URL (empty string while loading / on failure).
 */
function useAutoLoginUrl(): string {
  const { user } = useContext(UserContext) as UserContextProps;
  const { getUserAutoLoginToken } = useAPIAuth();
  const [autoLoginToken, setAutoLoginToken] = useState<string>('');

  useEffect(() => {
    const loadUserAutoLoginToken = async () => {
      const token = await getUserAutoLoginToken(
        user?.id as number,
        user?.token as {
          value: string;
          type: string;
        },
      );
      setAutoLoginToken(token || '');
    };
    loadUserAutoLoginToken();
  }, []);

  if (!autoLoginToken) {
    return '';
  }

  return `${window.location.origin}${ROUTES.AUTOLOGIN}?_token=${autoLoginToken}`;
}

export default useAutoLoginUrl;
